import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from '../Config/Config';

const removeStepMilestone = async (testStepId) => {
    const userDetails = localStorage.getItem("userDetail");
    if (!userDetails) throw new Error("No user details found in localStorage");

    const response = await axios.post(
        `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=removeStepMilestone&testStepId=${testStepId}`,
    )
    return response.data
}

const useRemoveStepMilestone = (options = {}) => {
    return useMutation({
        mutationFn: removeStepMilestone,
        ...options
    })
}
export default useRemoveStepMilestone;